import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Tooltip } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { CoeService, AdminService } from "../../../services/dataService";
import LearningUnitViewer from "./LearningUnitViewer";

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Icons ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);
const ChevronDown = ({ className = "", rotated = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={`transition-transform duration-300 ${rotated ? 'rotate-180' : ''} ${className}`}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const DotsTwo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="8.5" r="1.5" /><circle cx="12" cy="15.5" r="1.5" />
  </svg>
);
const VideoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);
const DotsVert = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="5" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="12" cy="19" r="1.5" />
  </svg>
);
const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" />
  </svg>
);
const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </svg>
);
const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18m-2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);
const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const WarningIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const Layers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </svg>
);
const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const UnlockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 9.9-1" />
  </svg>
);
const FileDoc = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
  </svg>
);
const X = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const PlusIcon = ({ size = 16, strokeWidth = 2.5 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const CATEGORIES = [
  { id: "coe_content", title: "COE Document", subtitle: "General COE Resources", accent: "blue", icon: <EyeIcon /> },
  { id: "lab_content", title: "Lab Content", subtitle: "Lab guides & manuals", accent: "blue", icon: <UploadIcon /> },
  { id: "fdp_content", title: "FDP Content", subtitle: "Faculty training resources", accent: "violet", icon: <CheckIcon /> },
  { id: "project_content", title: "Project Content", subtitle: "Student report database", accent: "emerald", icon: <EditIcon /> },
];

const ACCENT = {
  blue: { bg: "bg-blue-50", text: "text-blue-600", border: "border-blue-200", dot: "bg-blue-500", badge: "bg-blue-100 text-blue-600" },
  violet: { bg: "bg-violet-50", text: "text-violet-600", border: "border-violet-200", dot: "bg-violet-500", badge: "bg-violet-100 text-violet-600" },
  emerald: { bg: "bg-emerald-50", text: "text-emerald-600", border: "border-emerald-200", dot: "bg-emerald-500", badge: "bg-emerald-100 text-emerald-600" },
};

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Tiny Tailwind Dropdown (uses Portal for perfect visibility) ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const TailDropdown = ({ open, onClose, children, className = "", triggerElement }) => {
  const ref = useRef(null);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open, onClose]);

  useEffect(() => {
    if (open && triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      const scrollX = window.scrollX || window.pageXOffset;
      const scrollY = window.scrollY || window.pageYOffset;
      const midPoint = window.innerWidth / 2;

      const isRightSide = rect.left > midPoint;

      if (isRightSide) {
        // Align to RIGHT: calculate distance from right edge of viewport
        setCoords({
          top: rect.bottom + scrollY,
          right: window.innerWidth - (rect.right + scrollX),
          left: "auto",
          isRightAligned: true
        });
      } else {
        // Align to LEFT: calculate distance from left edge of viewport
        setCoords({
          top: rect.bottom + scrollY,
          left: rect.left + scrollX,
          right: "auto",
          isRightAligned: false
        });
      }
    }
  }, [open, triggerElement]);

  if (!open) return null;

  return createPortal(
    <motion.div
      ref={ref}
      initial={{ opacity: 0, scale: 0.95, y: -6 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95, y: -6 }}
      transition={{ duration: 0.12 }}
      style={{
        position: "absolute",
        top: (coords.top || 0) + 5,
        left: coords.left,
        right: coords.right,
        zIndex: 99999,
        minWidth: "160px"
      }}
      className={`bg-white rounded-xl border border-slate-100 shadow-2xl overflow-hidden ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </motion.div>,
    document.body
  );
};

const DropItem = ({ icon, label, color = "text-slate-600", hoverBg = "hover:bg-slate-50", onClick }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center gap-2.5 px-3.5 py-2 text-left text-[9px] font-bold uppercase tracking-wider ${color} ${hoverBg} transition-colors border-0 bg-transparent`}
  >
    <span className="flex-shrink-0 flex items-center justify-center w-4 h-4">{icon}</span>
    {label}
  </button>
);

const ConfirmDialog = ({ open, title, message, onConfirm, onCancel, loading }) => {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "Enter" && !loading) { e.preventDefault(); onConfirm(); }
      if (e.key === "Escape" && !loading) onCancel();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [open, loading, onConfirm, onCancel]);

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="absolute inset-0 bg-slate-900/30 backdrop-blur-sm" onClick={!loading ? onCancel : undefined} />
          <motion.div initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.92 }} className="relative bg-white rounded-2xl shadow-2xl w-full max-sm:w-full overflow-hidden" style={{ maxWidth: "400px" }}>
            <div className="h-1 w-full bg-gradient-to-r from-red-400 to-rose-500" />
            <div className="p-6">
              <div className="flex items-start gap-4 mb-4">
                <div className="p-2.5 bg-red-50 rounded-xl text-red-500 shrink-0 mt-0.5"><WarningIcon /></div>
                <div><p className="text-base font-extrabold text-slate-800 leading-tight">{title}</p><p className="text-[12px] text-slate-500 mt-1.5 leading-relaxed">{message}</p></div>
              </div>
              <div className="flex gap-2 mt-5">
                <button onClick={onCancel} disabled={loading} className="flex-1 py-2.5 rounded-xl text-[11px] font-bold uppercase tracking-wider text-slate-500 bg-slate-100 hover:bg-slate-200 transition-all">Cancel</button>
                <button onClick={onConfirm} disabled={loading} className="flex-1 py-2.5 rounded-xl text-[11px] font-bold uppercase tracking-wider text-white bg-red-500 hover:bg-red-600 transition-all shadow-md shadow-red-100">{loading ? "Deleting..." : "Yes, Delete"}</button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

const RecursiveFolderItem = ({ node, idxPath, uploadSections, setUploadSections }) => {
  const isRoot = idxPath.length === 1;
  const updateNode = (updater) => {
    const newSections = [...uploadSections];
    let current = newSections;
    for (let i = 0; i < idxPath.length - 1; i++) {
      current = current[idxPath[i]].children;
    }
    updater(current[idxPath[idxPath.length - 1]]);
    setUploadSections(newSections);
  };

  const removeNode = () => {
    const newSections = [...uploadSections];
    if (isRoot) {
      newSections.splice(idxPath[0], 1);
    } else {
      let current = newSections;
      for (let i = 0; i < idxPath.length - 2; i++) {
        current = current[idxPath[i]].children;
      }
      current[idxPath[idxPath.length - 2]].children.splice(idxPath[idxPath.length - 1], 1);
    }
    setUploadSections(newSections);
  };

  const addChild = () => {
    updateNode(n => {
      if (!n.children) n.children = [];
      n.children.push({ id: Date.now() + Math.random(), title: "", files: [], children: [] });
    });
  };

  const handleFiles = (e) => {
    const files = Array.from(e.target.files);
    updateNode(n => { n.files = [...(n.files || []), ...files]; });
    e.target.value = "";
  };

  const removeFile = (fi) => {
    updateNode(n => { n.files.splice(fi, 1); });
  };

  return (
    <div className={`flex flex-col gap-2 ${isRoot ? 'border border-slate-200 rounded-xl bg-white shadow-sm overflow-hidden shrink-0' : 'border-l-[3px] border-l-blue-400 pl-3 ml-2 mt-2'}`}>
      <div className={`flex items-center gap-3 ${isRoot ? 'px-4 py-3 bg-slate-50 border-b border-slate-100' : 'py-1'}`}>
        {isRoot && <div className="w-6 h-6 rounded-md bg-blue-600 text-white flex items-center justify-center shrink-0 text-[11px] font-black">{idxPath[0] + 1}</div>}
        <input
          type="text" value={node.title}
          onChange={e => updateNode(n => n.title = e.target.value)}
          placeholder={isRoot ? "e.g. FDP Class PPT" : "Sub-folder name"}
          className={`flex-1 bg-transparent border-0 outline-none font-bold text-slate-800 placeholder:text-slate-400 ${isRoot ? 'text-[13px]' : 'text-[12px]'}`}
        />
        {node.files?.length > 0 && (
          <span className="text-[10px] font-black text-blue-600 bg-blue-50 border border-blue-100 px-2 py-0.5 rounded-full shrink-0">{node.files.length} file{node.files.length !== 1 ? 's' : ''}</span>
        )}
        <button
          onClick={addChild}
          className={`text-[10px] font-bold ${isRoot ? 'text-emerald-600 border-emerald-200 hover:bg-emerald-50' : 'text-slate-600 border-slate-200 hover:bg-slate-50'} bg-white border shadow-sm px-2.5 py-1 rounded-md shrink-0 transition-all flex items-center gap-1`}
        >
          <PlusIcon size={10} /> Sub-folder
        </button>
        <label className={`text-[10px] font-bold ${isRoot ? 'text-blue-600 border-blue-200 hover:bg-blue-50' : 'text-slate-600 border-slate-200 hover:bg-slate-50'} bg-white border shadow-sm px-2.5 py-1 rounded-md shrink-0 cursor-pointer transition-all`}>
          + Files
          <input type="file" multiple className="hidden" onChange={handleFiles} />
        </label>
        <button onClick={removeNode} className="w-6 h-6 flex items-center justify-center rounded-md text-slate-300 hover:text-red-500 hover:bg-red-50 transition-all shrink-0"><X /></button>
      </div>
      
      <div className={isRoot ? 'px-4 py-3' : 'pb-2'}>
        {node.files?.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-2 max-h-[80px] overflow-y-auto custom-scrollbar">
            {node.files.map((f, fi) => (
              <span key={fi} className={`inline-flex items-center gap-1.5 bg-white border text-[9px] font-bold px-2 py-1 rounded-lg shadow-sm ${isRoot ? 'border-blue-100 text-blue-600' : 'border-slate-200 text-slate-600'}`}>
                <span className="truncate max-w-[150px]">{f.name}</span>
                <button onClick={() => removeFile(fi)} className="text-slate-300 hover:text-red-500 transition-colors ml-1"><X/></button>
              </span>
            ))}
          </div>
        )}
        
        {node.children && node.children.map((child, i) => (
          <RecursiveFolderItem key={child.id} node={child} idxPath={[...idxPath, i]} uploadSections={uploadSections} setUploadSections={setUploadSections} />
        ))}
      </div>
    </div>
  );
};

const RecursiveCategoryList = ({ parentId, subDocsMap, expandedSubDocs, setExpandedSubDocs, setViewingDoc, setDeleteTarget, toggleAction, actionOpen, closeAction, menuTriggerElMap, accessMap, handleToggleAccess, openUploadModal, setParentCoeId, renamingCat, setRenamingCat, handleRenameCategory, level }) => {
  const docs = subDocsMap[parentId] || [];
  const categories = docs.filter(d => d.is_folder).sort((a,b) => new Date(a.created_at) - new Date(b.created_at));
  const files = docs.filter(d => !d.is_folder).sort((a,b) => new Date(b.created_at) - new Date(a.created_at));

  return (
    <div className={`w-full flex flex-col ${level > 0 ? 'pl-6 border-l-[2px] border-l-slate-200 ml-4 mt-2' : ''}`}>
      {categories.map(cat => {
        const isExpanded = !!expandedSubDocs[cat.coe_id];
        const title = (cat.doc_title || "Unnamed Folder").trim();
        const catKey = `cat_${cat.coe_id}`;
        return (
          <div key={cat.coe_id} className="border-b border-slate-100 last:border-0">
            <div onClick={() => setExpandedSubDocs(prev => ({...prev, [cat.coe_id]: !prev[cat.coe_id]}))} className="flex items-center gap-5 px-6 py-4 cursor-pointer hover:bg-slate-50/50 transition-all">
              <div className="w-8 h-8 rounded-xl flex items-center justify-center bg-blue-50 text-blue-600 border border-blue-200 shadow-sm shrink-0"><FileDoc /></div>
              <div className="flex-1 min-w-0">
                <p className="text-[13px] font-black text-slate-800 truncate">{title}</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="relative" onClick={e => e.stopPropagation()}>
                  <button onClick={(e) => toggleAction(catKey, e.currentTarget)} className="w-8 h-8 flex items-center justify-center rounded-lg text-slate-500 hover:text-blue-600 hover:bg-blue-50 transition-colors">
                    <DotsVert />
                  </button>
                  <TailDropdown open={!!actionOpen[catKey]} onClose={() => closeAction(catKey)} triggerElement={menuTriggerElMap[catKey]} className="w-52">
                    <div className="py-1.5">
                      <DropItem icon={<TrashIcon />} label="Delete Category" color="text-red-500" hoverBg="hover:bg-red-50" onClick={() => { closeAction(catKey); setDeleteTarget({ coeId: cat.coe_id, docTitle: cat.doc_title, catId: cat.coe_id }); }} />
                      <DropItem icon={<UploadIcon />} label="Upload Documents" color="text-slate-600" onClick={() => { closeAction(catKey); openUploadModal(cat.coe_id, cat.doc_type); setParentCoeId(cat.coe_id); }} />
                      {/* <DropItem icon={<VideoIcon />} label="Upload Learning Unit" color="text-slate-600" onClick={() => { closeAction(catKey); openLearningUnitModal(cat.coe_id); }} /> */}
                    </div>
                  </TailDropdown>
                </div>
                <ChevronDown rotated={isExpanded} className="text-slate-400" />
              </div>
            </div>
            <AnimatePresence>
              {isExpanded && (
                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden bg-slate-50/30">
                  <RecursiveCategoryList parentId={cat.coe_id} subDocsMap={subDocsMap} expandedSubDocs={expandedSubDocs} setExpandedSubDocs={setExpandedSubDocs} setViewingDoc={setViewingDoc} setDeleteTarget={setDeleteTarget} toggleAction={toggleAction} actionOpen={actionOpen} closeAction={closeAction} menuTriggerElMap={menuTriggerElMap} accessMap={accessMap} handleToggleAccess={handleToggleAccess} openUploadModal={openUploadModal} setParentCoeId={setParentCoeId} renamingCat={renamingCat} setRenamingCat={setRenamingCat} handleRenameCategory={handleRenameCategory} level={level + 1} />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}

      {files.length > 0 && (
        <div className={`flex flex-col gap-2 p-4 ${level === 0 ? 'bg-white' : 'bg-transparent'}`}>
          {files.map(doc => {
            const hasChildren = subDocsMap[doc.coe_id] && subDocsMap[doc.coe_id].length > 0;
            const isExpanded = !!expandedSubDocs[doc.coe_id];
            
            return (
              <div key={doc.coe_id} className="flex flex-col">
                <div 
                  onClick={() => hasChildren && setExpandedSubDocs(prev => ({...prev, [doc.coe_id]: !prev[doc.coe_id]}))}
                  className={`flex items-center gap-4 p-4 bg-white rounded-xl border border-slate-200 shadow-sm hover:border-blue-300 transition-all ${hasChildren ? 'cursor-pointer' : ''}`}
                >
                  <div className="flex-1 min-w-0">
                    <p className="text-[13px] font-black text-slate-800 truncate">{doc.doc_title}</p>
                  </div>
                  <div className="flex gap-2 items-center">
                    <div className="relative" onClick={e => e.stopPropagation()}>
                      <IconButton onClick={(e) => toggleAction(`doc_${doc.coe_id}`, e.currentTarget)} size="small" sx={{ color: "#94a3b8", "&:hover": { color: "#059669", bgcolor: "white" } }}><DotsVert /></IconButton>
                      <TailDropdown open={!!actionOpen[`doc_${doc.coe_id}`]} onClose={() => closeAction(`doc_${doc.coe_id}`)} triggerElement={menuTriggerElMap[`doc_${doc.coe_id}`]} className="w-52">
                        <div className="py-1.5">
                          <DropItem icon={<TrashIcon />} label="Delete File" color="text-red-500" hoverBg="hover:bg-red-50" onClick={() => { closeAction(`doc_${doc.coe_id}`); setDeleteTarget({ coeId: doc.coe_id, docTitle: doc.doc_title, catId: parentId }); }} />
                          <DropItem icon={<UploadIcon />} label="Upload Documents" color="text-slate-600" onClick={() => { closeAction(`doc_${doc.coe_id}`); openUploadModal(doc.coe_id, doc.doc_type); setParentCoeId(doc.coe_id); }} />
                          {/* <DropItem icon={<VideoIcon />} label="Upload Learning Unit" color="text-slate-600" onClick={() => { closeAction(`doc_${doc.coe_id}`); openLearningUnitModal(doc.coe_id); }} /> */}
                        </div>
                      </TailDropdown>
                    </div>
                    <IconButton onClick={(e) => { e.stopPropagation(); /* if(doc.doc_type === 'learning_unit') { setViewingUnitId(doc.unit_id); } else */ { setViewingDoc(doc); } }} size="small" sx={{ color: "#94a3b8", "&:hover": { color: "#2563eb", bgcolor: "white" } }}><EyeIcon /></IconButton>
                    {hasChildren && <ChevronDown rotated={isExpanded} className="text-slate-400 ml-1" />}
                  </div>
                </div>
                
                <AnimatePresence>
                  {isExpanded && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                      <RecursiveCategoryList 
                        parentId={doc.coe_id} 
                        subDocsMap={subDocsMap} 
                        expandedSubDocs={expandedSubDocs} 
                        setExpandedSubDocs={setExpandedSubDocs} 
                        setViewingDoc={setViewingDoc} 
                        setDeleteTarget={setDeleteTarget} 
                        toggleAction={toggleAction} 
                        actionOpen={actionOpen} 
                        closeAction={closeAction} 
                        menuTriggerElMap={menuTriggerElMap} 
                        accessMap={accessMap} 
                        handleToggleAccess={handleToggleAccess} 
                        openUploadModal={openUploadModal} 
                        setParentCoeId={setParentCoeId} 
                        renamingCat={renamingCat} 
                        setRenamingCat={setRenamingCat} 
                        handleRenameCategory={handleRenameCategory} 
                        level={level + 1} 
                      />
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const CoeAdminFeatures = () => {
  const { academyId, domainId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Local State
  const [corporateName, setCorporateName] = useState("Corporate");
  const [domainName, setDomainName] = useState(location.state?.domainName || "Domain");
  const [loading, setLoading] = useState(true);
  const [panelOpen, setPanelOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [actionOpen, setActionOpen] = useState({});
  const [expandedCat, setExpandedCat] = useState({});
  const [uploadModal, setUploadModal] = useState({ open: false, catId: null });
  const [uploadItems, setUploadItems] = useState([]);
  const [uploadTitle, setUploadTitle] = useState("");
  const [uploadModalSubCat, setUploadModalSubCat] = useState("");
  const [renamingCat, setRenamingCat] = useState({ catKey: null, coeId: null, value: "" });
  const [selectedInstitute, setSelectedInstitute] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [viewingDoc, setViewingDoc] = useState(null);
  const [viewingUnitId, setViewingUnitId] = useState(null);
  const [institutes, setInstitutes] = useState([]);
  const [docs, setDocs] = useState({ coe_content: [], fdp_content: [], lab_content: [], project_content: [] });
  const [hierarchicalDocs, setHierarchicalDocs] = useState({}); // { parent_id: { coe: doc, children: { fdp: [], lab: [], project: [] } } }
  const [orphanedDocs, setOrphanedDocs] = useState({ fdp_content: [], lab_content: [], project_content: [] });
  const [subDocsMap, setSubDocsMap] = useState({});
  const [expandedSubDocs, setExpandedSubDocs] = useState({});
  const [selectedIds, setSelectedIds] = useState({ coe_content: "", fdp_content: "", lab_content: "", project_content: "" });
  const [multiUploadOpen, setMultiUploadOpen] = useState(false);
  const [multiFiles, setMultiFiles] = useState({ coe: null, lab: null, fdp: null, project: null });
  const [multiTitle, setMultiTitle] = useState("");
  const [multiCoeName, setMultiCoeName] = useState("");
  const [multiCoeDomain, setMultiCoeDomain] = useState("");
  const [parentCoeId, setParentCoeId] = useState(null);
  const [addCategoryModal, setAddCategoryModal] = useState({ open: false, coeId: null });
  const [newCatName, setNewCatName] = useState("");
  const [newSubCatName, setNewSubCatName] = useState("");
  const [addSubCategoryModal, setAddSubCategoryModal] = useState({ open: false, parentCatId: null, parentCatSlug: null });
  const [newSubCategoryInput, setNewSubCategoryInput] = useState("");
  const [generating, setGenerating] = useState(false);
  const [boardGroupExpanded, setBoardGroupExpanded] = useState({});
   const [accessMap, setAccessMap] = useState({}); // { coe_id: is_active }
 
   // Permission management state (multi-select)
   const [permInstitute, setPermInstitute] = useState({}); // { coe_id: [instId1, instId2, ...] }
   const [permCategories, setPermCategories] = useState(() => {
     const saved = localStorage.getItem('coe_perm_cats');
     return saved ? JSON.parse(saved) : {};
   });
   const [permStatus, setPermStatus] = useState({}); // {coe_id: bool}
   const [catDropOpen, setCatDropOpen] = useState({}); // {coe_id: bool}
   const [instDropOpen, setInstDropOpen] = useState({}); // {coe_id: bool}

  // New Upload Manager State
  const [uploadManagerOpen, setUploadManagerOpen] = useState(false);
  const [managerCorpId, setManagerCorpId] = useState(academyId);
  const [managerDomainId, setManagerDomainId] = useState(domainId);
  const [allAcademies, setAllAcademies] = useState([]);
  const [managerDomains, setManagerDomains] = useState([]);
  const [uploadSections, setUploadSections] = useState([]);
  const [uploadManagerCoeId, setUploadManagerCoeId] = useState(null);
  const [abortController, setAbortController] = useState(null);

  // Learning Unit Upload State
  // const [learningUnitModalOpen, setLearningUnitModalOpen] = useState(false);
  // const [learningUnitData, setLearningUnitData] = useState({
  //   title: "",
  //   duration: "",
  //   videoFile: null,
  //   pdfFile: null,
  //   steps_json: [],
  // });
  // const [learningUnitProgress, setLearningUnitProgress] = useState({ video: 0, pdf: 0 });
  // const [learningUnitUploading, setLearningUnitUploading] = useState(false);
  // const [learningUnitParentId, setLearningUnitParentId] = useState(null);

  const countFiles = (nodes) => nodes.reduce((acc, n) => acc + (n.files?.length || 0) + (n.children ? countFiles(n.children) : 0), 0);

  // REFS for positioning ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Â per-key trigger map to avoid shared state corruption
  const uploadBtnRef = useRef(null);
  const [menuTriggerElMap, setMenuTriggerElMap] = useState({});

  useEffect(() => { fetchData(); }, [academyId, domainId]);

  useEffect(() => {
    if (uploadManagerOpen) {
      setManagerCorpId(academyId);
      setManagerDomainId(domainId);
      setUploadSections([{ id: Date.now(), title: "", files: [], children: [] }]);
    }
  }, [uploadManagerOpen, academyId, domainId]);

  // Global keyboard handler — Enter = primary action, Escape = close, for every modal
  useEffect(() => {
    const handler = (e) => {
      if (submitting) return;

      // Upload Manager: Enter → Save & Upload
      if (uploadManagerOpen) {
        if (e.key === "Escape") { e.preventDefault(); setUploadManagerOpen(false); }
        if (e.key === "Enter" && countFiles(uploadSections) > 0) { e.preventDefault(); handleManagerSave(); }
        return;
      }

      // Create COE modal: Enter → handleMultiUpload (input already handles it, but backdrop Escape)
      if (multiUploadOpen) {
        if (e.key === "Escape") { e.preventDefault(); setMultiUploadOpen(false); }
        // Enter on input is handled by the input's own onKeyDown
        return;
      }

      // Upload files modal: Escape to close
      if (uploadModal.open) {
        if (e.key === "Escape") { e.preventDefault(); closeUploadModal(); }
        return;
      }

      // Add Category modal: Escape to close
      if (addCategoryModal.open) {
        if (e.key === "Escape") { e.preventDefault(); setAddCategoryModal({ open: false, coeId: null }); setNewCatName(""); setNewSubCatName(""); }
        return;
      }

      // Add Sub-Category modal: Escape to close
      if (addSubCategoryModal.open) {
        if (e.key === "Escape") { e.preventDefault(); setAddSubCategoryModal({ open: false, parentCatId: null, parentCatSlug: null }); setNewSubCategoryInput(""); }
        return;
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [
    submitting, uploadManagerOpen, uploadSections, multiUploadOpen, multiTitle,
    uploadModal.open, addCategoryModal.open, addSubCategoryModal.open, newCatName, newSubCategoryInput
  ]);



  const handleToggleAccess = async (doc) => {
    const currentAccess = accessMap[doc.coe_id] !== undefined ? accessMap[doc.coe_id] : (doc.is_active !== false);
    const newAccess = !currentAccess;
    // Optimistic update
    setAccessMap(prev => ({ ...prev, [doc.coe_id]: newAccess }));
    try {
      await CoeService.updateDocument(doc.coe_id, { is_active: newAccess });
    } catch (e) {
      // Revert on failure
      setAccessMap(prev => ({ ...prev, [doc.coe_id]: currentAccess }));
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const [corpRes, docsRes, instsRes] = await Promise.allSettled([
        CoeService.getActiveAcademies(),
        CoeService.getDocumentsByDomain(domainId, academyId),
        CoeService.getInstitutesByDomain(academyId, domainId),
      ]);
      if (corpRes.status === "fulfilled" && corpRes.value?.data) {
        const corps = Array.isArray(corpRes.value.data) ? corpRes.value.data : [];
        setAllAcademies(corps);
        const corp = corps.find((c) => String(c.academy_id) === String(academyId));
        if (corp) setCorporateName(corp.academy_name);
      }
      if (instsRes.status === "fulfilled" && instsRes.value?.data) {
        setInstitutes(Array.isArray(instsRes.value.data) ? instsRes.value.data : []);
      }
      if (docsRes.status === "fulfilled" && docsRes.value?.data) {
        const raw = docsRes.value.data;

        // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Index every doc for O(1) parent lookups ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
        const docById = {};
        raw.forEach(d => { docById[d.coe_id] = d; });

        const hierarchy = {};
        // Backend now returns only docs for this exact domain_id, so no extra filter needed
        raw.filter(d => d.doc_type === "coe_panel").forEach(coe => {
          hierarchy[coe.coe_id] = { coe, children: {}, catNames: {} };
        });

        const newChildrenMap = {};
        raw.forEach(d => {
          if (!newChildrenMap[d.parent_id]) newChildrenMap[d.parent_id] = [];
          newChildrenMap[d.parent_id].push(d);
        });

        Object.keys(hierarchy).forEach(coeId => {
          const rootCats = newChildrenMap[coeId] || [];
          rootCats.forEach(cat => {
            if (cat.is_folder) {
              hierarchy[coeId].catNames[cat.coe_id] = cat.doc_title.trim();
            }
          });
        });

        setHierarchicalDocs(hierarchy);
        setSubDocsMap(newChildrenMap);

        // Initialize permission states from DB
        const initialPermInst = {};
        const initialPermCats = {};
        
        Object.keys(hierarchy).forEach(coeId => {
          const mainDoc = hierarchy[coeId].coe;
          initialPermInst[coeId] = mainDoc.allowed_institute_ids || [];
          
          // For categories, check which child folders have access enabled
          const children = newChildrenMap[coeId] || [];
          const activeCats = children
            .filter(c => c.is_folder && (c.is_active !== false))
            .map(c => c.doc_title.trim());
          initialPermCats[coeId] = activeCats;
        });
        
        setPermInstitute(initialPermInst);
        setPermCategories(initialPermCats);

        const grouped = { coe_content: [], fdp_content: [], lab_content: [], project_content: [] };
        raw.forEach(d => { if (!grouped[d.doc_type]) grouped[d.doc_type] = []; grouped[d.doc_type].push(d); });
        const ids = {};
        Object.keys(grouped).forEach(k => { if (grouped[k].length > 0) ids[k] = grouped[k][0].coe_id; });
        setSelectedIds(ids);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const toEmbedUrl = (link) => {
    if (!link) return "";
    const m = link.match(/\/d\/([a-zA-Z0-9_-]+)/);
    return m ? `https://drive.google.com/file/d/${m[1]}/preview` : link;
  };

  const handleViewDoc = (doc) => {
    if (doc?.doc_link) setViewingDoc(doc);
    else alert("No document link available.");
  };

  const handleViewActive = (catId) => {
    const doc = (docs[catId] || []).find((d) => String(d.coe_id) === String(selectedIds[catId]));
    if (doc) handleViewDoc(doc);
  };


  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      const coeIdStr = String(deleteTarget.coeId);
      if (coeIdStr.startsWith("lu_")) {
        const unitId = coeIdStr.replace("lu_", "");
        await CoeService.deleteLearningUnit(unitId);
      } else {
        // Backend handles full cascade deletion (children + Google Drive) automatically
        await CoeService.deleteDocument(deleteTarget.coeId);
      }
      setDeleteTarget(null);
      fetchData();
    } catch (e) {
      alert("Failed to delete. Please try again. " + (e?.response?.data?.detail || e?.message || ""));
    } finally {
      setDeleting(false);
    }
  };

  // Delete ALL legacy/orphaned documents in one click
  const handleDeleteLegacy = async () => {
    const legacyGroup = hierarchicalDocs["legacy"];
    if (!legacyGroup) return;
    if (!window.confirm("Delete ALL old/legacy documents? This cannot be undone.")) return;
    setSubmitting(true);
    try {
      const ids = [];
      Object.values(legacyGroup.children || {}).forEach(docs => docs.forEach(d => ids.push(d.coe_id)));
      await Promise.allSettled(ids.map(id => CoeService.deleteDocument(id)));
      fetchData();
    } catch (e) {
      alert("Failed to delete legacy docs: " + (e?.message || ""));
    } finally {
      setSubmitting(false);
    }
  };
//   const openLearningUnitModal = (catId) => {
//     setLearningUnitParentId(catId);
//     setLearningUnitData({
//       title: "",
//       duration: "",
//       videoFile: null,
//       pdfFile: null,
//       steps_json: [],
//     });
//     setLearningUnitProgress({ video: 0, pdf: 0 });
//     setLearningUnitModalOpen(true);
//   };
// 
//   const handleLearningUnitUpload = async () => {
//     if (!learningUnitData.title || !learningUnitData.videoFile || !learningUnitData.pdfFile) {
//       alert("Please provide a title, a video file, and a PDF file.");
//       return;
//     }
// 
//     setLearningUnitUploading(true);
//     setLearningUnitProgress({ video: 0, pdf: 0 });
// 
//     try {
//       // 1. Get pre-signed URLs
//       const urlsResponse = await CoeService.getUploadUrls({
//         academy_id: parseInt(academyId),
//         domain_id: parseInt(domainId),
//         filename_video: learningUnitData.videoFile.name,
//         filename_pdf: learningUnitData.pdfFile.name,
//         content_type_video: learningUnitData.videoFile.type || "video/mp4",
//         content_type_pdf: learningUnitData.pdfFile.type || "application/pdf"
//       });
// 
//       const { video_upload_url, pdf_upload_url, video_s3_key, pdf_s3_key } = urlsResponse.data;
// 
//       // 2. Upload Video
//       const uploadVideo = new Promise((resolve, reject) => {
//         const xhr = new XMLHttpRequest();
//         xhr.open("PUT", video_upload_url, true);
//         xhr.setRequestHeader("Content-Type", learningUnitData.videoFile.type || "video/mp4");
//         xhr.upload.onprogress = (e) => {
//           if (e.lengthComputable) {
//             setLearningUnitProgress(p => ({ ...p, video: Math.round((e.loaded / e.total) * 100) }));
//           }
//         };
//         xhr.onload = () => {
//           if (xhr.status >= 200 && xhr.status < 300) resolve();
//           else reject(new Error("Video upload failed"));
//         };
//         xhr.onerror = () => reject(new Error("Video upload failed"));
//         xhr.send(learningUnitData.videoFile);
//       });
// 
//       // 3. Upload PDF
//       const uploadPdf = new Promise((resolve, reject) => {
//         const xhr = new XMLHttpRequest();
//         xhr.open("PUT", pdf_upload_url, true);
//         xhr.setRequestHeader("Content-Type", learningUnitData.pdfFile.type || "application/pdf");
//         xhr.upload.onprogress = (e) => {
//           if (e.lengthComputable) {
//             setLearningUnitProgress(p => ({ ...p, pdf: Math.round((e.loaded / e.total) * 100) }));
//           }
//         };
//         xhr.onload = () => {
//           if (xhr.status >= 200 && xhr.status < 300) resolve();
//           else reject(new Error("PDF upload failed"));
//         };
//         xhr.onerror = () => reject(new Error("PDF upload failed"));
//         xhr.send(learningUnitData.pdfFile);
//       });
// 
//       await Promise.all([uploadVideo, uploadPdf]);
// 
//       // 4. Save metadata
//       await CoeService.saveLearningUnit({
//         parent_id: learningUnitParentId,
//         title: learningUnitData.title,
//         video_s3_key: video_s3_key,
//         pdf_s3_key: pdf_s3_key,
//         video_duration: learningUnitData.duration,
//         pdf_size: learningUnitData.pdfFile.size,
//         video_size: learningUnitData.videoFile.size
//       });
// 
//       alert("Learning unit saved successfully!");
//       setLearningUnitModalOpen(false);
//       fetchData(); // Refresh UI
// 
//     } catch (e) {
//       console.error(e);
//       alert("Error saving learning unit: " + (e.message || "Unknown error"));
//     } finally {
//       setLearningUnitUploading(false);
//     }
//   };

  const openUploadModal = (catId, slug = null) => {
    setUploadItems([]);
    setUploadTitle("");
    setUploadModalSubCat("");
    setSelectedInstitute("");
    setUploadModal({ open: true, catId, slug });
  };

  const closeUploadModal = () => {
    setUploadModal({ open: false, catId: null });
    setUploadItems([]);
    setUploadTitle("");
    setUploadModalSubCat("");
  };

  const handleCreateCategory = async () => {
    if (!newCatName) return alert("Please enter a category name");
    setSubmitting(true);
    try {
      const names = newCatName.split(',').map(n => n.trim()).filter(Boolean);
      const subNames = newSubCatName ? newSubCatName.split(',').map(n => n.trim()).filter(Boolean) : [];
      
      for (const name of names) {
        const typeSlug = name.toLowerCase().replace(/[^a-z0-9]/g, '_');
        const payload = {
          academy_id: parseInt(academyId),
          domain_id: parseInt(domainId),
          domain_name: domainName,
          doc_type: typeSlug,
          doc_title: name,
          doc_link: "",
          parent_id: addCategoryModal.coeId,
          is_folder: true
        };
        await CoeService.addDocument(payload);
      }

      // Create sub-categories under the first category created
      if (subNames.length > 0 && names.length > 0) {
        const parentSlug = names[0].toLowerCase().replace(/[^a-z0-9]/g, '_');
        for (const subName of subNames) {
          const subSlug = `${parentSlug}_sub_${subName.toLowerCase().replace(/[^a-z0-9]/g, '_')}`;
          const subPayload = {
            academy_id: parseInt(academyId),
            domain_id: parseInt(domainId),
            domain_name: domainName,
            doc_type: subSlug,
            doc_title: subName,
            doc_link: "",
            parent_id: addCategoryModal.coeId,
            is_folder: true
          };
          await CoeService.addDocument(subPayload);
        }
      }

      setAddCategoryModal({ open: false, coeId: null });
      setNewCatName("");
      setNewSubCatName("");
      fetchData();
    } catch (e) {
      alert("Failed to add category: " + (e.response?.data?.detail || e.message));
    } finally {
      setSubmitting(false);
    }
  };

  const handleCreateSubCategory = async () => {
    if (!newSubCategoryInput.trim()) return alert("Please enter a sub-category name");
    setSubmitting(true);
    try {
      const subName = newSubCategoryInput.trim();
      const parentSlug = addSubCategoryModal.parentCatSlug;
      const subSlug = `${parentSlug}_sub_${subName.toLowerCase().replace(/[^a-z0-9]/g, '_')}`;
      
      const payload = {
        academy_id: parseInt(academyId),
        domain_id: parseInt(domainId),
        domain_name: domainName,
        doc_type: subSlug,
        doc_title: subName,
        doc_link: "",
        parent_id: addSubCategoryModal.parentCatId,
        is_folder: true
      };
      
      await CoeService.addDocument(payload);
      setAddSubCategoryModal({ open: false, parentCatId: null, parentCatSlug: null });
      setNewSubCategoryInput("");
      fetchData();
    } catch (e) {
      alert("Failed to add sub-category: " + (e.response?.data?.detail || e.message));
    } finally {
      setSubmitting(false);
    }
  };

  const handleManagerSave = async () => {
    if (!managerDomainId) return alert("Please select a domain");

    if (uploadSections.length === 0) {
      return alert("Please add at least one folder.");
    }

    const controller = new AbortController();
    setAbortController(controller);
    setSubmitting(true);
    
    try {
      const processNode = async (node, parentId) => {
        const slug = "fdp_content"; // Backend supports any depth, default to fdp_content
        
        // Create Category marker
        const catRes = await CoeService.addDocument({
          academy_id: parseInt(managerCorpId),
          domain_id: parseInt(managerDomainId),
          domain_name: domainName,
          doc_type: slug,
          doc_title: node.title,
          doc_link: "",
          parent_id: parentId,
          is_folder: true,
          is_active: true
        }, { signal: controller.signal });
        const newParentId = catRes?.data?.coe_id || parentId;

        // Process Files
        if (node.files && node.files.length > 0) {
          for (const file of node.files) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("academy_id", managerCorpId);
            formData.append("domain_id", managerDomainId);
            formData.append("domain_name", domainName);
            formData.append("doc_type", slug);
            formData.append("parent_id", newParentId);
            formData.append("doc_title", file.name.replace(/\.[^/.]+$/, ""));
            formData.append("is_active", "true");
            await CoeService.uploadDocument(formData, { signal: controller.signal });
          }
        }

        // Process Children recursively
        if (node.children && node.children.length > 0) {
          for (const child of node.children) {
            await processNode(child, newParentId);
          }
        }
      };

      for (const sec of uploadSections) {
        await processNode(sec, uploadManagerCoeId);
      }

      setUploadManagerOpen(false);
      fetchData();
      alert("Sections and files uploaded successfully!");
    } catch (e) {
      if (e.name === 'CanceledError' || e.message === 'canceled') {
        alert("Upload was canceled.");
      } else {
        alert("Error during save: " + (e.response?.data?.detail || e.message));
      }
    } finally {
      setSubmitting(false);
      setAbortController(null);
    }
  };


  const handleRenameCategory = async (catData) => {
    if (!catData.value.trim()) return setRenamingCat({ catKey: null, coeId: null, value: "" });
    setSubmitting(true);
    try {
      const newTitle = catData.value.trim();
      if (catData.coeId) {
        await CoeService.updateDocument(catData.coeId, { doc_title: newTitle });
      } else if (catData.isHeading && catData.parentCoeId) {
        await CoeService.addDocument({
          academy_id: parseInt(academyId),
          domain_id: parseInt(domainId),
          domain_name: domainName,
          doc_type: "fdp_content",
          doc_title: newTitle,
          doc_link: "",
          is_folder: true,
          parent_id: catData.parentCoeId
        });
      }
      fetchData();
    } catch (e) {
      alert("Failed to rename category: " + (e.response?.data?.detail || e.message));
    } finally {
      setRenamingCat({ catKey: null, coeId: null, value: "" });
      setSubmitting(false);
    }
  };

  const handleUpload = async () => {
    if (uploadItems.length === 0) return alert("Please select at least one file to upload.");
    const missingTitle = uploadItems.find(item => !item.title.trim());
    if (missingTitle) return alert("Please ensure all files have a title.");

    setSubmitting(true);
    try {
      let targetParentId = parentCoeId;
      let targetDocType = uploadModal.slug || uploadModal.catId;

      // Inline Sub-Category Creation
      if (uploadModalSubCat.trim()) {
        const subName = uploadModalSubCat.trim();
        const subRes = await CoeService.addDocument({
          academy_id: parseInt(academyId),
          domain_id: parseInt(domainId),
          domain_name: domainName,
          doc_type: "fdp_content",
          doc_title: subName,
          doc_link: "",
          parent_id: targetParentId,
          is_folder: true
        });
        targetParentId = subRes?.data?.coe_id || targetParentId;
        targetDocType = "fdp_content";
      }

      if (uploadItems.length === 1) {
        // Single file — use existing single endpoint
        const formData = new FormData();
        formData.append("file", uploadItems[0].file);
        formData.append("academy_id", academyId);
        formData.append("domain_id", domainId);
        formData.append("domain_name", domainName);
        formData.append("doc_type", targetDocType);
        if (targetParentId) formData.append("parent_id", targetParentId);
        formData.append("doc_title", uploadItems[0].title.trim());
        await CoeService.uploadDocument(formData);
      } else {
        // Multiple files — use concurrent bulk endpoint (much faster)
        const formData = new FormData();
        formData.append("academy_id", academyId);
        formData.append("domain_id", domainId);
        formData.append("domain_name", domainName);
        formData.append("doc_type", targetDocType);
        if (targetParentId) formData.append("parent_id", targetParentId);
        formData.append("titles", JSON.stringify(uploadItems.map(item => item.title.trim())));
        uploadItems.forEach(item => formData.append("files", item.file));

        const res = await CoeService.uploadDocumentBulk(formData);
        const { uploaded, failed, errors: uploadErrors } = res.data || {};
        if (failed > 0) {
          alert(`Uploaded ${uploaded}/${uploadItems.length} files. ${failed} failed:\n${uploadErrors.join("\n")}`);
        }
      }

      // Auto-expand the target folder so the user sees the new files immediately
      if (targetParentId) {
        setExpandedSubDocs(prev => ({ ...prev, [targetParentId]: true }));
      }

      closeUploadModal();
      fetchData();
    } catch (e) {
      alert("Upload failed: " + (e?.response?.data?.detail || e?.message || "Unknown error"));
    } finally {
      setSubmitting(false);
    }
  };


  const handleMultiUpload = async () => {
    if (!multiTitle) return alert("Please enter a COE Title.");

    setSubmitting(true);
    try {
      const payload = {
        academy_id: parseInt(managerCorpId),
        domain_id: parseInt(managerDomainId),
        domain_name: domainName,
        doc_type: "coe_panel",
        doc_title: multiTitle,
        doc_link: "",
        is_active: true
      };

      await CoeService.addDocument(payload);

      setMultiUploadOpen(false);
      setMultiFiles({ coe: null, lab: null, fdp: null, project: null });
      setMultiTitle("");
      setMultiCoeName("");
      setMultiCoeDomain("");
      fetchData();
    } catch (e) {
      alert("Creation failed: " + (e.response?.data?.detail || e.message));
    } finally {
      setSubmitting(false);
    }
  };

  const handleGenerateBandsInsideCoe = async (coeId) => {
    if (!window.confirm("Are you sure you want to instantly generate the 13 Boards inside this container?")) return;
    setSubmitting(true);
    try {
      const promises = [];
      for (let i = 1; i <= 13; i++) {
        const payload = {
          academy_id: parseInt(academyId),
          domain_id: parseInt(domainId),
          domain_name: domainName,
          doc_type: `board_${i}`,
          doc_title: `[CATEGORY] Board ${i}`,
          doc_link: "",
          parent_id: coeId
        };
        promises.push(CoeService.addDocument(payload));
      }
      await Promise.allSettled(promises);
      fetchData();
    } catch (e) {
      alert("Failed to generate boards: " + (e.message || "Unknown error"));
    } finally {
      setSubmitting(false);
    }
  };

  const toggleAction = (key, targetElement) => {
    setMenuTriggerElMap(prev => ({ ...prev, [key]: targetElement }));
    setActionOpen(prev => ({ ...prev, [key]: !prev[key] }));
  };
  const closeAction = (key) => setActionOpen(prev => ({ ...prev, [key]: false }));
  const toggleExpand = (catId) => setExpandedCat(prev => ({ ...prev, [catId]: !prev[catId] }));
  const toggleBoardGroup = (coeId, e) => {
    if (e) e.stopPropagation();
    setBoardGroupExpanded(prev => ({ ...prev, [coeId]: !prev[coeId] }));
  };


  return (
    <div className="min-h-screen bg-slate-50 p-5 font-sans">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
        {/* Header */}
        <div className="flex items-center justify-between mb-7">
          <div className="flex items-center gap-4">
            <Tooltip title="Back"><IconButton onClick={() => navigate(`/admin-coe/${academyId}`)} sx={{ bgcolor: "white", border: "1px solid #e2e8f0", width: 44, height: 44 }}><ArrowBackIcon sx={{ fontSize: 20, color: "#2563eb" }} /></IconButton></Tooltip>
            <div><span className="text-xl font-extrabold text-blue-600 tracking-tight">{domainName.replace(/\s*#\d+$/, '')}</span> <span className="text-slate-300 mx-2 text-xl font-light">/</span> <span className="text-xl font-bold text-slate-700 tracking-tight">COE</span></div>
          </div>
          <button
            onClick={() => setMultiUploadOpen(true)}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl text-[12px] font-black uppercase tracking-widest transition-all shadow-lg shadow-blue-100 hover:scale-[1.02] active:scale-95"
          >
            <PlusIcon size={16} strokeWidth={3} />
            Create COE
          </button>
        </div>

        {/* Hierarchical COE Panels */}
        <div className="mb-12">
          <table className="w-full border-separate border-spacing-y-4">
            <thead>
              <tr className="text-blue-600/80">
                <th className="px-8 py-2 text-left text-[11px] font-black uppercase tracking-[0.2em]">Module Details</th>
                <th className="px-6 py-2 text-left text-[11px] font-black uppercase tracking-[0.2em]">Granular Access Management</th>
                <th className="px-6 py-2 text-center text-[11px] font-black uppercase tracking-[0.2em]">Resources</th>
                <th className="px-8 py-2 text-right text-[11px] font-black uppercase tracking-[0.2em]">Operations</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(hierarchicalDocs).length === 0 && (
                <tr>
                  <td colSpan={4} className="p-0 pt-4">
                    <div className="flex flex-col items-center justify-center p-20 bg-white border border-dashed border-slate-200 rounded-3xl shadow-sm">
                      <div className="w-20 h-20 bg-slate-50 border border-slate-100 rounded-2xl flex items-center justify-center text-slate-300 mb-6 shadow-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></svg>
                      </div>
                      <h3 className="text-xl font-black text-slate-700">No COE Containers Found</h3>
                      <p className="text-[13px] font-bold text-slate-400 mt-3 text-center max-w-sm">No COE containers are available for this domain. Use the button above to create a new COE panel.</p>
                    </div>
                  </td>
                </tr>
              )}
          {Object.values(hierarchicalDocs).map((group, gIdx) => {
            const coe = group.coe;
            const children = group.children;
            const isGroupExpanded = !!expandedCat[coe.coe_id];

             return (
               <React.Fragment key={coe.coe_id}>
                 <tr className={`group transition-all ${coe.is_legacy ? 'bg-amber-50/5' : ''}`}>
                   <td className="px-8 py-6 cursor-pointer bg-white border-y border-l border-slate-100 first:rounded-l-2xl shadow-[0_2px_10px_rgba(0,0,0,0.02)]" onClick={() => toggleExpand(coe.coe_id)}>
                     <div className="flex items-center gap-4">
                       <div className={`w-10 h-10 rounded-xl flex items-center justify-center border shadow-sm transition-all group-hover:scale-110 ${coe.is_legacy ? 'bg-amber-100 border-amber-200 text-amber-600' : 'bg-blue-50 border-blue-100 text-blue-600'}`}>
                         <span className="text-[14px] font-black">{gIdx + 1}</span>
                       </div>
                       <div>
                         <p className="text-[13px] font-black text-slate-800 uppercase tracking-tight leading-none">{coe.doc_title || "Primary COE"}</p>
                       </div>
                     </div>
                   </td>

                   <td className="px-6 py-6 bg-white border-y border-slate-100 shadow-[0_2px_10px_rgba(0,0,0,0.02)]">
                     {!coe.is_legacy && (
                       <div className="flex items-center gap-3" onClick={e => e.stopPropagation()}>

                         {/* ── Multi-Select Institute Dropdown ── */}
                         <div className="relative">
                           <button
                             onClick={() => setInstDropOpen(prev => ({ ...prev, [coe.coe_id]: !prev[coe.coe_id] }))}
                             className="flex items-center justify-between gap-2 text-[9px] font-black text-slate-700 bg-white border border-slate-100 pl-3 pr-2 py-2 rounded-lg outline-none hover:border-blue-400 hover:shadow-md transition-all w-[220px] shadow-sm"
                           >
                             <span className="truncate">
                               {(permInstitute[coe.coe_id] || []).length === 0
                                 ? "All Institutes (Global)"
                                 : `${(permInstitute[coe.coe_id] || []).length} Institute${(permInstitute[coe.coe_id] || []).length > 1 ? 's' : ''} Selected`}
                             </span>
                             <ChevronDown size={12} className={`shrink-0 text-slate-400 transition-transform duration-300 ${instDropOpen[coe.coe_id] ? "rotate-180 text-blue-500" : ""}`} />
                           </button>

                           <AnimatePresence>
                             {instDropOpen[coe.coe_id] && (
                               <motion.div
                                 initial={{ opacity: 0, y: 8, scale: 0.97 }}
                                 animate={{ opacity: 1, y: 0, scale: 1 }}
                                 exit={{ opacity: 0, y: 8, scale: 0.97 }}
                                 transition={{ duration: 0.15 }}
                                 className="absolute top-full left-0 mt-1 w-72 bg-white border border-slate-100 shadow-[0_16px_40px_rgba(0,0,0,0.12)] rounded-xl z-[200] py-2 overflow-hidden"
                               >
                                 {/* Select All / Clear */}
                                 <div
                                   className="flex items-center gap-2.5 px-3 py-2 cursor-pointer hover:bg-slate-50 border-b border-slate-50"
                                   onClick={() => {
                                     const selected = permInstitute[coe.coe_id] || [];
                                     if (selected.length === institutes.length) {
                                       setPermInstitute(prev => ({ ...prev, [coe.coe_id]: [] }));
                                     } else {
                                       setPermInstitute(prev => ({ ...prev, [coe.coe_id]: institutes.map(i => i.institue_id || i.institute_id) }));
                                     }
                                   }}
                                 >
                                   <div className={`w-4 h-4 rounded border-2 flex items-center justify-center transition-all ${(permInstitute[coe.coe_id] || []).length === institutes.length && institutes.length > 0 ? "border-blue-500 bg-blue-500" : "border-slate-300 bg-white"}`}>
                                     {(permInstitute[coe.coe_id] || []).length === institutes.length && institutes.length > 0 && <CheckIcon />}
                                   </div>
                                   <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest">Select All</span>
                                 </div>

                                 <div className="max-h-44 overflow-y-auto">
                                   {institutes.length === 0 ? (
                                     <div className="text-[9px] text-slate-400 text-center py-3 px-3">No enrolled institutes found</div>
                                   ) : institutes.map(inst => {
                                     const instId = inst.institue_id || inst.institute_id;
                                     const selected = (permInstitute[coe.coe_id] || []).includes(instId);
                                     return (
                                       <div
                                         key={instId}
                                         className={`flex items-center gap-2.5 px-3 py-2 cursor-pointer transition-all ${selected ? "bg-blue-50/50" : "hover:bg-slate-50"}`}
                                         onClick={() => {
                                           const current = permInstitute[coe.coe_id] || [];
                                           setPermInstitute(prev => ({
                                             ...prev,
                                             [coe.coe_id]: selected ? current.filter(id => id !== instId) : [...current, instId]
                                           }));
                                         }}
                                       >
                                         <div className={`w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 transition-all ${selected ? "border-blue-500 bg-blue-500" : "border-slate-200 bg-white"}`}>
                                           {selected && <CheckIcon />}
                                         </div>
                                         <span className={`text-[9px] font-bold truncate ${selected ? "text-blue-800" : "text-slate-600"}`}>{inst.institute_name}</span>
                                       </div>
                                     );
                                   })}
                                 </div>

                                 <div className="px-3 pt-2 border-t border-slate-50 flex items-center justify-between gap-2">
                                   <span className="text-[8px] text-slate-400 font-medium">
                                     {(permInstitute[coe.coe_id] || []).length === 0 ? "Global (all institutes)" : `${(permInstitute[coe.coe_id] || []).length} selected`}
                                   </span>
                                   <button
                                     onClick={() => setInstDropOpen(prev => ({ ...prev, [coe.coe_id]: false }))}
                                     className="text-[8px] text-blue-600 font-black hover:underline"
                                   >Done</button>
                                 </div>
                               </motion.div>
                             )}
                           </AnimatePresence>
                         </div>

                         {/* ── Categories Dropdown ── */}
                         <div className="relative">
                           <button 
                             onClick={(e) => setCatDropOpen(prev => ({ ...prev, [coe.coe_id]: !prev[coe.coe_id] }))}
                             className="flex items-center justify-between gap-3 text-[9px] font-black text-slate-700 bg-white border border-slate-100 px-3 py-2 rounded-lg outline-none hover:border-blue-400 hover:shadow-md transition-all w-[160px] truncate shadow-sm"
                           >
                             <span className="flex items-center gap-1.5">
                               <div className="w-1 h-1 rounded-full bg-blue-500 shadow-[0_0_6px_rgba(59,130,246,0.5)]" />
                               {(permCategories[coe.coe_id] || []).length === 0 ? "Categories" : `${permCategories[coe.coe_id].length} Selected`}
                             </span>
                             <ChevronDown size={12} className={`text-slate-400 transition-transform duration-300 ${catDropOpen[coe.coe_id] ? "rotate-180 text-blue-500" : ""}`} />
                           </button>

                           <AnimatePresence>
                             {catDropOpen[coe.coe_id] && (
                               <motion.div 
                                 initial={{ opacity: 0, y: 10, scale: 0.95 }}
                                 animate={{ opacity: 1, y: 0, scale: 1 }}
                                 exit={{ opacity: 0, y: 10, scale: 0.95 }}
                                 className="absolute top-full left-0 mt-2 w-64 bg-white border border-slate-100 shadow-[0_20px_50px_rgba(0,0,0,0.15)] rounded-xl z-[100] py-2 overflow-hidden backdrop-blur-xl"
                               >
                                 <div className="px-3 py-2 border-b border-slate-50">
                                   <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest">Choose document categories</span>
                                 </div>
                                 <div className="py-1 max-h-60 overflow-y-auto">
                                   {(subDocsMap[coe.coe_id] || []).filter(c => c.is_folder).length === 0 && (
                                     <div className="px-4 py-3 text-[9px] text-slate-400 font-bold text-center uppercase tracking-widest italic">No folders created yet</div>
                                   )}
                                   {(subDocsMap[coe.coe_id] || []).filter(c => c.is_folder).map(catFolder => {
                                     const name = catFolder.doc_title.trim();
                                     const isSelected = (permCategories[coe.coe_id] || []).includes(name);
                                     return (
                                       <div 
                                         key={catFolder.coe_id}
                                         onClick={() => {
                                           const current = permCategories[coe.coe_id] || [];
                                           if (isSelected) setPermCategories(prev => ({ ...prev, [coe.coe_id]: current.filter(c => c !== name) }));
                                           else setPermCategories(prev => ({ ...prev, [coe.coe_id]: [...current, name] }));
                                         }}
                                         className={`flex items-center gap-2.5 px-3 py-2 rounded-lg cursor-pointer transition-all ${isSelected ? "bg-blue-50/50" : "hover:bg-slate-50"}`}
                                       >
                                         <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${isSelected ? "border-blue-500 bg-white scale-105 shadow-sm" : "border-slate-200 bg-white"}`}>
                                           {isSelected && <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="w-2 h-2 rounded-full bg-blue-500 shadow-sm" />}
                                         </div>
                                         <span className={`text-[10px] font-black tracking-tight ${isSelected ? "text-blue-800" : "text-slate-600"}`}>{name}</span>
                                       </div>
                                     );
                                   })}
                                 </div>
                                 <div className="mt-2 px-2 pt-2 border-t border-slate-50 flex justify-end">
                                   <button 
                                     onClick={async () => {
                                       const selInstIds = permInstitute[coe.coe_id] || [];
                                       const selCats = permCategories[coe.coe_id] || [];
                                       

                                       
                                       try {
                                         setPermStatus(prev => ({ ...prev, [coe.coe_id]: "loading" }));
                                         
                                         // 1. Update main COE Panel access
                                         await CoeService.updateDocument(coe.coe_id, {
                                           allowed_institute_ids: selInstIds,
                                           is_active: true,
                                         });

                                         // 2. Update each category folder
                                         const children = subDocsMap[coe.coe_id] || [];
                                         const folderUpdatePromises = children
                                           .filter(c => c.is_folder)
                                           .map(folder => {
                                             const folderTitle = folder.doc_title.trim();
                                             const isSelected = selCats.includes(folderTitle);
                                             return CoeService.updateDocument(folder.coe_id, {
                                               allowed_institute_ids: selInstIds,
                                               is_active: isSelected
                                             });
                                           });
                                         
                                         await Promise.all(folderUpdatePromises);

                                         setPermStatus(prev => ({ ...prev, [coe.coe_id]: "success" }));
                                         setTimeout(() => setPermStatus(prev => ({ ...prev, [coe.coe_id]: null })), 2500);
                                         setCatDropOpen(prev => ({ ...prev, [coe.coe_id]: false }));
                                         setInstDropOpen(prev => ({ ...prev, [coe.coe_id]: false }));
                                         
                                         // Refresh data to reflect changes
                                         // fetchData(); // Optional: might be too heavy, but ensures sync
                                       } catch (err) {
                                         console.error(err);
                                         setPermStatus(prev => ({ ...prev, [coe.coe_id]: "error" }));
                                         alert("Failed to grant access. Please try again.");
                                       }
                                     }} 
                                     className="text-[9px] font-black text-white bg-emerald-600 uppercase tracking-widest px-4 py-1.5 hover:bg-emerald-700 rounded-lg shadow-md transition-all active:scale-95 flex items-center gap-2"
                                   >
                                     <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>
                                     {permStatus[coe.coe_id] === "loading" ? "Updating..." : 
                                      permStatus[coe.coe_id] === "success" ? "Access Granted ✓" : 
                                      permStatus[coe.coe_id] === "error" ? "Error!" : "Give Access"}
                                   </button>
                                 </div>
                               </motion.div>
                             )}
                           </AnimatePresence>
                         </div>

                       </div>
                     )}
                   </td>

                   <td className="px-6 py-6 text-center bg-white border-y border-slate-100 shadow-[0_2px_10px_rgba(0,0,0,0.02)]">
                     {!coe.is_legacy ? (
                       <button
                          onClick={(e) => { e.stopPropagation(); setUploadManagerOpen(true); setUploadManagerCoeId(coe.coe_id); }}
                          className="flex items-center justify-center gap-1.5 bg-blue-50/50 hover:bg-blue-600 text-blue-600 hover:text-white px-3 py-1.5 rounded-lg text-[8px] font-black uppercase tracking-widest border border-blue-100 hover:border-blue-600 active:scale-95 transition-all mx-auto group shadow-sm"
                        >
                           <UploadIcon className="w-3 h-3" />
                          Upload
                        </button>
                     ) : (
                       <span className="text-[9px] font-black text-amber-600 bg-amber-50 px-3 py-1.5 rounded-lg border border-amber-100 uppercase tracking-widest">Legacy</span>
                     )}
                   </td>

                   <td className="px-8 py-6 text-right bg-white border-y border-r border-slate-100 last:rounded-r-2xl shadow-[0_2px_10px_rgba(0,0,0,0.02)]">
                     <div className="flex items-center justify-end gap-2">
                       <button
                         onClick={(e) => { e.stopPropagation(); setDeleteTarget({ coeId: coe.coe_id, docTitle: coe.doc_title || "Primary COE", catId: "coe_content" }); }}
                         className="w-8 h-8 flex items-center justify-center rounded-xl text-rose-500 bg-rose-50/50 hover:bg-rose-100 hover:border-rose-200 border border-transparent transition-all"
                       >
                         <TrashIcon size={16} />
                       </button>
                       <button 
                         onClick={() => toggleExpand(coe.coe_id)}
                         className={`w-8 h-8 flex items-center justify-center rounded-xl border transition-all ${isGroupExpanded ? "bg-blue-50 border-blue-100 text-blue-600 shadow-inner" : "bg-white border-slate-100 text-slate-400 hover:border-blue-200"}`}
                       >
                         <ChevronDown size={18} className={`transition-transform duration-300 ${isGroupExpanded ? "rotate-180" : ""}`} />
                       </button>
                     </div>
                   </td>
                 </tr>

                 <AnimatePresence>
                   {isGroupExpanded && (
                     <tr className="animate-in fade-in slide-in-from-top-2 duration-300">
                       <td colSpan={4} className="p-0">
                         <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0 }} className="overflow-hidden bg-white/50 border border-slate-100 rounded-2xl mt-[-12px] mb-4 mx-4 shadow-inner">
                           <div className="divide-y divide-slate-100 p-2">
                             <RecursiveCategoryList 
                               parentId={coe.coe_id} 
                               subDocsMap={subDocsMap} 
                               expandedSubDocs={expandedSubDocs} 
                               setExpandedSubDocs={setExpandedSubDocs}
                               setViewingDoc={setViewingDoc}
                               setDeleteTarget={setDeleteTarget}
                               toggleAction={toggleAction}
                               actionOpen={actionOpen}
                               closeAction={closeAction}
                               menuTriggerElMap={menuTriggerElMap}
                               accessMap={accessMap}
                               handleToggleAccess={handleToggleAccess}
                               openUploadModal={openUploadModal}
                               setParentCoeId={setParentCoeId}
                               renamingCat={renamingCat}
                               setRenamingCat={setRenamingCat}
                               handleRenameCategory={handleRenameCategory}
                               level={0}
                             />
                           </div>
                    </motion.div>
                  </td>
                </tr>
              )}
            </AnimatePresence>
                   </React.Fragment>
                 );
               })}
             </tbody>
           </table>
         </div>
       </motion.div>

      {createPortal(
        <AnimatePresence>
          {deleteTarget && (
            <ConfirmDialog open={!!deleteTarget} title="Remove Document" message={<>Are you sure you want to delete <strong className="text-slate-800">"{deleteTarget?.docTitle}"</strong>? This cannot be undone.</>} onConfirm={confirmDelete} onCancel={() => setDeleteTarget(null)} loading={deleting} />
          )}
        </AnimatePresence>,
        document.body
      )}

      {createPortal(
        <AnimatePresence>
          {addCategoryModal.open && (
            <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4">
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={!submitting ? () => setAddCategoryModal({ open: false, coeId: null }) : undefined} />
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
                <div className="p-7">
                  <h2 className="text-lg font-extrabold text-slate-800 mb-5">Create New Category</h2>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider mb-2">Category Name(s)</label>
                      <input type="text" value={newCatName} onChange={e => setNewCatName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && !submitting && newCatName) handleCreateCategory(); }} placeholder="e.g. Band 1, Band 2, Lab Manual" className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-blue-100 outline-none transition" />
                    </div>
                    <div>
                       <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider mb-2">Sub Folder (Optional)</label>
                       <input type="text" value={newSubCatName} onChange={e => setNewSubCatName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && !submitting && newCatName) handleCreateCategory(); }} placeholder="e.g. Sub Topic 1, Sub Topic 2" className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-blue-100 outline-none transition" />
                     </div>
                    <div className="flex gap-3 pt-2">
                      <button onClick={() => { setAddCategoryModal({ open: false, coeId: null }); setNewCatName(""); setNewSubCatName(""); }} disabled={submitting} className="flex-1 py-3 rounded-xl font-bold text-[11px] uppercase bg-slate-100 text-slate-500">Cancel</button>
                      <button onClick={handleCreateCategory} disabled={submitting || !newCatName} className={`flex-1 py-3 rounded-xl font-bold text-[11px] uppercase text-white shadow-lg ${newCatName ? "bg-blue-600 shadow-blue-100" : "bg-slate-200 shadow-none"}`}>{submitting ? "Saving..." : "Create"}</button>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>,
        document.body
      )}

      {createPortal(
        <AnimatePresence>
          {addSubCategoryModal.open && (
            <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4">
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={!submitting ? () => setAddSubCategoryModal({ open: false, parentCatId: null, parentCatSlug: null }) : undefined} />
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
                <div className="p-7">
                  <h2 className="text-xl font-extrabold text-slate-800 mb-6">Add Sub-Category</h2>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-[11px] font-black text-slate-400 uppercase tracking-widest mb-2.5">Sub-Category Name</label>
                      <input
                        type="text"
                        value={newSubCategoryInput}
                        onChange={e => setNewSubCategoryInput(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter' && !submitting && newSubCategoryInput.trim()) handleCreateSubCategory(); }}
                        placeholder="e.g. Module 1"
                        autoFocus
                        className="w-full bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 text-sm font-bold text-slate-700 focus:ring-4 focus:ring-blue-50 focus:bg-white outline-none transition-all"
                      />
                    </div>
                    <div className="flex gap-3 pt-3">
                      <button onClick={() => { setAddSubCategoryModal({ open: false, parentCatId: null, parentCatSlug: null }); setNewSubCategoryInput(""); }} disabled={submitting} className="flex-1 py-3 rounded-xl font-bold text-[11px] uppercase bg-slate-100 text-slate-500 hover:bg-slate-200 transition-colors">Cancel</button>
                      <button onClick={handleCreateSubCategory} disabled={submitting || !newSubCategoryInput.trim()} className={`flex-1 py-3 rounded-xl font-bold text-[11px] uppercase text-white shadow-lg transition-colors ${newSubCategoryInput.trim() ? "bg-blue-600 shadow-blue-100 hover:bg-blue-700" : "bg-slate-200 shadow-none"}`}>{submitting ? "Adding..." : "Add"}</button>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>,
        document.body
      )}

      {createPortal(
        <AnimatePresence>
          {uploadModal.open && (() => {
            const catId = uploadModal.catId;
            const cat = CATEGORIES.find(c => c.id === catId);
            const g = hierarchicalDocs[parentCoeId] || { catNames: {} };
            const fallbackTitle = g.catNames[catId] || (catId ? String(catId).replace(/_/g, ' ') : "Document");
            const finalTitle = cat ? cat.title : fallbackTitle;
            const ac = ACCENT[cat?.accent || "blue"];
            return (
              <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4">
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={!submitting ? closeUploadModal : undefined} />
                <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
                  <div className={`h-1 w-full ${ac.dot}`} />
                  <div className="p-7">
                    <h2 className="text-lg font-extrabold text-slate-800 mb-5">Upload</h2>
                    <form className="space-y-4" onSubmit={e => { e.preventDefault(); if (!submitting && uploadItems.length > 0 && uploadItems.every(i => i.title.trim())) handleUpload(); }}>

                      <div>
                        <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider mb-2">Sub Folder (Optional)</label>
                        <input
                           type="text"
                           value={uploadModalSubCat}
                           onChange={e => setUploadModalSubCat(e.target.value)}
                           placeholder="e.g. Module 1"
                           className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-blue-100 outline-none transition"
                        />
                      </div>

                      <div>
                        <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider mb-2">Upload Files Here</label>
                        <div onClick={() => document.getElementById("file-up").click()} className={`border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-all ${uploadItems.length > 0 ? "hover:bg-slate-50 border-slate-200" : "bg-slate-50 border-slate-200 text-slate-400"}`}>
                          <input id="file-up" type="file" className="hidden" accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip,.rar,.txt" multiple onChange={e => {
                          const files = Array.from(e.target.files);
                          const newItems = files.map((file, index) => ({
                            file,
                            title: (files.length === 1 && uploadTitle) ? uploadTitle : file.name.replace(/\.[^/.]+$/, "")
                          }));
                          setUploadItems(prev => [...prev, ...newItems]);
                        }} />
                        <div className="flex flex-col items-center gap-1">
                          <UploadIcon />
                          <p className="text-sm font-medium">Click to select files</p>
                          <p className="text-[10px] text-slate-400 uppercase tracking-widest">Multiple allowed</p>
                        </div>
                        </div>
                      </div>

                      {uploadItems.length > 0 && (
                        <div className="max-h-48 overflow-y-auto space-y-2 pr-1">
                          {uploadItems.map((item, idx) => (
                            <div key={idx} className="flex items-center gap-3 bg-slate-50 rounded-xl p-3 border border-slate-100">
                              <div className={`w-8 h-8 rounded-lg flex items-center justify-center bg-blue-100 text-blue-600`}><UploadIcon /></div>
                              <input
                                type="text"
                                value={item.title}
                                onChange={e => {
                                  const copy = [...uploadItems];
                                  copy[idx].title = e.target.value;
                                  setUploadItems(copy);
                                }}
                                className="flex-1 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-xs focus:ring-2 focus:ring-blue-100 outline-none"
                                placeholder="Document Title"
                                onKeyDown={e => { if (e.key === 'Enter' && !submitting && uploadItems.every(i => i.title.trim())) handleUpload(); }}
                              />
                              <button onClick={() => setUploadItems(uploadItems.filter((_, i) => i !== idx))} className="text-slate-400 hover:text-red-500 transition-colors p-1"><TrashIcon /></button>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="flex gap-3 pt-2">
                        <button type="button" onClick={closeUploadModal} disabled={submitting} className="flex-1 py-3 rounded-xl font-bold text-[11px] uppercase bg-slate-100 text-slate-500">Cancel</button>
                        <button type="submit" disabled={submitting || uploadItems.length === 0} className={`flex-1 py-3 rounded-xl font-bold text-[11px] uppercase text-white shadow-lg ${uploadItems.length > 0 ? "bg-blue-600 shadow-blue-100" : "bg-slate-200 shadow-none"}`}>{submitting ? `Uploading ${uploadItems.length > 1 ? "Files..." : "..."}` : `Upload ${uploadItems.length > 1 ? uploadItems.length + " Files" : "File"}`}</button>
                      </div>
                    </form>
                  </div>
                </motion.div>
              </div>
            );
          })()}
        </AnimatePresence>,
        document.body
      )}

      {createPortal(
        <AnimatePresence>
          {multiUploadOpen && (
            <div className="fixed inset-0 z-[1000] flex items-center justify-center p-6 bg-slate-900/40 backdrop-blur-sm">
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="bg-white rounded-3xl w-full max-w-md overflow-hidden shadow-2xl border border-white">
                <div className="bg-slate-50 px-8 py-6 border-b border-slate-100 flex items-center justify-between">
                  <div>
                    <h2 className="text-xl font-black text-slate-800">Create New COE</h2>
                    <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-1.5 flex items-center gap-2">
                      <span className="text-blue-600">Define a new COE Container</span>
                    </p>
                  </div>
                  <button onClick={() => setMultiUploadOpen(false)} className="w-8 h-8 rounded-full bg-white border border-slate-100 text-slate-400 flex items-center justify-center hover:bg-red-50 hover:text-red-500 transition-all"><TrashIcon /></button>
                </div>

                <div className="p-8 space-y-6">
                  <div className="space-y-4">
                    <div>
                      <label className="block text-[11px] font-black text-slate-800 uppercase tracking-widest mb-2.5">COE Title</label>
                      <input
                        type="text"
                        value={multiTitle}
                        onChange={e => setMultiTitle(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter' && !submitting && multiTitle) handleMultiUpload(); }}
                        placeholder="e.g. AWS Cloud COE 2"
                        className="w-full bg-slate-50/50 border border-slate-100 rounded-2xl px-6 py-4 text-sm font-bold text-slate-700 focus:ring-4 focus:ring-blue-50 focus:bg-white outline-none transition-all"
                      />
                    </div>
                  </div>
                </div>

                <div className="p-8 bg-slate-50 flex gap-4 border-t border-slate-100">
                  <button
                    onClick={() => setMultiUploadOpen(false)}
                    className="flex-1 py-4 rounded-2xl font-black text-[11px] uppercase tracking-[0.2em] bg-white border border-slate-100 text-slate-400 hover:bg-slate-100 transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleMultiUpload}
                    disabled={submitting || !multiTitle}
                    className={`flex-1 py-4 rounded-2xl font-black text-[11px] uppercase tracking-[0.2em] transition-all shadow-xl bg-blue-600 text-white ${submitting || !multiTitle ? "cursor-not-allowed shadow-none opacity-80" : "hover:bg-blue-700 hover:shadow-blue-200 hover:scale-[1.02] active:scale-95"}`}
                  >
                    {submitting ? "Creating..." : "Create Panel"}
                  </button>
                </div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>,
        document.body
      )}

      {createPortal(
        <AnimatePresence>
          {viewingDoc && (
            <div className="fixed inset-0 z-[100001] flex flex-col bg-slate-900">
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="flex items-center justify-between px-6 py-4 bg-slate-800 border-b border-slate-700 shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-lg shadow-blue-500/20"><EyeIcon /></div>
                  <div>
                    <h3 className="text-white font-extrabold text-sm tracking-tight leading-none">{viewingDoc.doc_title}</h3>
                    <p className="text-slate-400 text-[10px] font-bold uppercase tracking-widest mt-1.5">{corporateName} ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¢ {domainName}</p>
                  </div>
                </div>
                <button onClick={() => setViewingDoc(null)} className="w-9 h-9 rounded-full bg-slate-700 text-slate-300 flex items-center justify-center hover:bg-red-500 hover:text-white transition-all shadow-inner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
                </button>
              </motion.div>

              <motion.div initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="flex-1 relative overflow-hidden bg-slate-900 flex items-center justify-center">
                <iframe src={toEmbedUrl(viewingDoc.doc_link)} className="w-full h-full border-0" title={viewingDoc.doc_title} allow="autoplay" />
                <div className="absolute top-0 right-0 w-32 h-14 bg-slate-900 z-50 pointer-events-auto" />
                <div className="absolute bottom-0 right-0 w-[80px] h-[15px] bg-[#333] z-50" />
              </motion.div>
            </div>
          )}
        </AnimatePresence>,
        document.body
      )}
      {/* Ã¢â€â‚¬Ã¢â€â‚¬ COE Document Upload Manager Modal Ã¢â€â‚¬Ã¢â€â‚¬ */}
      {createPortal(
        <AnimatePresence>
          {uploadManagerOpen && (
            <div className="fixed inset-0 z-[100000] flex items-end sm:items-center justify-center p-0 sm:p-4">
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => {
                if (submitting && abortController) abortController.abort();
                setUploadManagerOpen(false);
              }} />
              <motion.div
                initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }}
                className="relative bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl w-full sm:max-w-2xl max-h-[92vh] flex flex-col overflow-hidden"
                onClick={e => e.stopPropagation()}
              >
                <div className="flex items-center justify-between px-7 pt-7 pb-5 border-b border-slate-100 shrink-0">
                  <div>
                    <h2 className="text-[18px] font-black text-slate-800 tracking-tight">Add Documents</h2>
                    <p className="text-[11px] text-slate-400 font-bold uppercase tracking-widest mt-1">Add Folders · drop files · optionally add Sub-Folderss</p>
                  </div>
                  <button onClick={() => {
                    if (submitting && abortController) abortController.abort();
                    setUploadManagerOpen(false);
                  }} className="w-9 h-9 flex items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-red-50 hover:text-red-500 transition-all"><X /></button>
                </div>

                <div className="flex-1 min-h-0 overflow-y-auto px-6 py-5 flex flex-col gap-3" style={{ scrollbarWidth: 'thin' }}>
                  {uploadSections.length === 0 && (
                    <div className="flex flex-col items-center justify-center py-20 text-center gap-5">
                      <div className="w-24 h-24 rounded-[2rem] bg-slate-50 flex items-center justify-center text-slate-200 border-2 border-dashed border-slate-100 shadow-inner">
                        <UploadIcon />
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <p className="text-[17px] font-black text-slate-800 tracking-tight">Your upload space is empty</p>
                        <p className="text-[12px] text-slate-400 font-medium max-w-xs mx-auto">Start by adding a category to organize your documents.</p>
                      </div>
                    </div>
                  )}

                  {uploadSections.map((sec, idx) => (
                    <RecursiveFolderItem key={sec.id} node={sec} idxPath={[idx]} uploadSections={uploadSections} setUploadSections={setUploadSections} />
                  ))}

                  <button
                    onClick={() => setUploadSections([...uploadSections, { id: Date.now() + Math.random(), title: "", files: [], children: [] }])}
                    className="group flex items-center justify-center gap-2 bg-slate-50/50 hover:bg-blue-50 border border-dashed border-slate-200 hover:border-blue-300 rounded-xl py-3 transition-all shrink-0 mt-4 active:scale-[0.98]"
                  >
                    <PlusIcon size={14} className="text-blue-500 group-hover:text-blue-600 transition-all" />
                    <span className="text-[11px] font-black uppercase tracking-widest text-blue-500 group-hover:text-blue-700 transition-all">Create New Folder</span>
                  </button>
                </div>

                <div className="shrink-0 flex items-center justify-between gap-4 px-7 py-5 border-t border-slate-100 bg-slate-50/50">
                  <div className="text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                    {countFiles(uploadSections)} Files · {uploadSections.length} Folders
                  </div>
                  <div className="flex gap-3">
                    <button 
                      onClick={() => {
                        if (submitting && abortController) {
                          abortController.abort();
                        }
                        setUploadManagerOpen(false);
                      }} 
                      className="px-5 py-2.5 rounded-xl text-[12px] font-bold text-slate-500 bg-white border border-slate-200 hover:bg-slate-100 transition-all"
                    >
                      {submitting ? "Cancel Upload" : "Cancel"}
                    </button>
                    <button onClick={handleManagerSave} disabled={submitting || uploadSections.length === 0 || uploadSections.some(s => !s.title.trim())} className={`px-7 py-2.5 rounded-xl text-[12px] font-black text-white transition-all shadow-sm ${submitting || uploadSections.length === 0 || uploadSections.some(s => !s.title.trim()) ? "bg-slate-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 hover:shadow-md"}`}>
                      {submitting ? "Uploading..." : "Save & Upload"}
                    </button>
                  </div>
                </div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>,
        document.body
      )}
      {/* ─── Learning Unit Upload Modal ─── */}
      {/* {createPortal(
        <AnimatePresence>
          {learningUnitModalOpen && (
            <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4">
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setLearningUnitModalOpen(false)} />
              <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="relative bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col">
                <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100">
                  <div>
                    <h2 className="text-lg font-black text-slate-800">Add Learning Unit</h2>
                    <p className="text-xs text-slate-500 mt-1">Upload a Video and a matching PDF guide.</p>
                  </div>
                  <button onClick={() => setLearningUnitModalOpen(false)} className="text-slate-400 hover:text-red-500 transition-colors"><X size={20} /></button>
                </div>
                
                <div className="p-6 flex flex-col gap-4 overflow-y-auto max-h-[70vh]">
                  <div>
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">Unit Title *</label>
                    <input type="text" value={learningUnitData.title} onChange={e => setLearningUnitData({...learningUnitData, title: e.target.value})} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none" placeholder="e.g. Robot Building Tutorial" />
                  </div>
                  
                  <div>
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">Duration (Optional)</label>
                    <input type="text" value={learningUnitData.duration} onChange={e => setLearningUnitData({...learningUnitData, duration: e.target.value})} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none" placeholder="e.g. 5:20" />
                  </div>

                  <div className="p-4 border border-dashed border-slate-300 rounded-xl bg-slate-50">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">Video File (.mp4) *</label>
                    <input type="file" accept="video/mp4" onChange={e => setLearningUnitData({...learningUnitData, videoFile: e.target.files[0]})} className="text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                    {learningUnitUploading && <div className="mt-2 w-full bg-slate-200 rounded-full h-1.5 flex"><div className="bg-blue-600 h-1.5 rounded-full transition-all duration-300" style={{width: `${learningUnitProgress.video}%`}}></div></div>}
                  </div>

                  <div className="p-4 border border-dashed border-slate-300 rounded-xl bg-slate-50">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">PDF Guide (.pdf) *</label>
                    <input type="file" accept="application/pdf" onChange={e => setLearningUnitData({...learningUnitData, pdfFile: e.target.files[0]})} className="text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-rose-50 file:text-rose-700 hover:file:bg-rose-100" />
                    {learningUnitUploading && <div className="mt-2 w-full bg-slate-200 rounded-full h-1.5 flex"><div className="bg-rose-600 h-1.5 rounded-full transition-all duration-300" style={{width: `${learningUnitProgress.pdf}%`}}></div></div>}
                  </div>
                </div>

                <div className="px-6 py-4 border-t border-slate-100 bg-slate-50 flex justify-end gap-3">
                  <button onClick={() => setLearningUnitModalOpen(false)} className="px-5 py-2.5 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-200 transition-colors">Cancel</button>
                  <button onClick={handleLearningUnitUpload} disabled={learningUnitUploading} className="px-6 py-2.5 rounded-xl text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 transition-colors shadow-sm">{learningUnitUploading ? "Uploading..." : "Upload Unit"}</button>
                </div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>,
        document.body
      )} */}
      
      {/* {viewingUnitId && <LearningUnitViewer unitId={viewingUnitId} onClose={() => setViewingUnitId(null)} />} */}
    </div>
  );
};
export default CoeAdminFeatures;







